<!-- Zweck: Stellt die HTML-Struktur für shop merklisten button component im Frontend bereit. -->
<div style="display: inline-block">
  @if ((mlsvc.primary_merkliste$|async)) {
    <button (click)="addToPrimaryMerkliste()" (contextmenu)="showMenu($event)" [disabled]="disabled"
      mat-icon-button
      matTooltipPosition="left"
      matTooltip="Zur Merkliste '{{(mlsvc.primary_merkliste$|async)?.label}}' hinzufügen. (R-Klick für Auswahl)">
      <svg-icon color="{{disabled ? 'grey' : '#9E24BAFF'}}">in-merkliste</svg-icon>
    </button>
  }
</div>
